import React from 'react';
import Arrow from './Arrow.js';

export default function DrawingEdge({drawingEdge}) {
    if (drawingEdge === undefined) {
        return (
            <rect x={0} y={0} width={0} height={0}/>
        );
    }

    let {x1, y1, x2, y2} = drawingEdge;

    return (
        <Arrow
          pointerLength= {6}
          pointerWidth={4}
          points={[x1, y1, (x1 + x2) / 2, (y1 + y2) / 2, x2, y2, x2, y2]}
          strokeWidth={2}
          stroke={"red"}/>
    );
}

